import script from "./CareerYouthProgramsTemplatePage.vue?vue&type=script&setup=true&lang=js"
export * from "./CareerYouthProgramsTemplatePage.vue?vue&type=script&setup=true&lang=js"

import "./CareerYouthProgramsTemplatePage.vue?vue&type=style&index=0&id=56fd65e8&lang=scss"

const __exports__ = script;

export default __exports__